import { IRootState } from '../../../store'
import { IDefaultsState } from '../store/defaults.types'

export const getDefaultsSelector = (state: IRootState): IDefaultsState => state.defaults
